/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Alexander Golshtein
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { ScrollbarStyled } from '@components/common/Scrollbar/ScrollbarStyled';
import { FIXED_SIZE_LIST_HEIGHT, SELECT_LIST_VERTICAL_PADDING } from '@components/common/Select/constants';
import { fonts, select } from '@theme/index';


interface ISelectContainerStyled {
    kind?: string;
    maxWidth?: string;
    $isLoading?: boolean
};

const SelectContainerStyled = styled.div.attrs<ISelectContainerStyled>(({ kind }: { kind: string }) => ({
    kind: kind,
}))<ISelectContainerStyled>`
    position: fixed;
    z-index: 101;
    width: auto;
    min-width: fit-content;
    overflow: auto;
    box-sizing: border-box;
    background-color: ${select.bgColor};
    box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.2);
    & .select__select-list {
        max-width: ${props => props.maxWidth ?? '500px'};
        margin: 0;
        padding: ${SELECT_LIST_VERTICAL_PADDING}px 0;
        overflow-y: auto;
        list-style: none;
        background-color: ${select.bgColor};
        &:not(.vurtual){
            max-height: ${FIXED_SIZE_LIST_HEIGHT}px;
        }
        &.virtual {
            min-height: ${props => props.$isLoading ? `${FIXED_SIZE_LIST_HEIGHT}px` : 'auto'};
            & > div {
                position: relative;
            }
        }
        ${ScrollbarStyled};

        &::-webkit-scrollbar {
            width: 8px;
        }
    }
    &.ext-filter-select .select__select-item {
        display: flex;
        align-items: center;
        height: 40px;
        ${fonts.textMain};
    }
`;

const SelectItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
`

export {
    SelectContainerStyled,
    SelectItemStyled,
};
